import { createContext } from "react";

export const ThemedContext = createContext({
  isDark: true, // default value
});
